module.exports= {
  apiURI: 'https://ootf02i23l.execute-api.us-west-2.amazonaws.com/v1/'
};



//////////////////
// WEBPACK FOOTER
// ./config/prod/config.js
// module id = 397
// module chunks = 0